import { render, staticRenderFns } from "./IndexTen.vue?vue&type=template&id=7af7522c&"
import script from "./IndexTen.vue?vue&type=script&lang=js&"
export * from "./IndexTen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports